import restClient from 'config/httpClient';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { createNotification } from 'modules/notifications/actions';
import { MESSAGE_RECEIVED_FROM_SOCKET } from 'modules/websockets/actionTypes';
import { isCreatedByMyself } from 'common/Messages/utils';

import { FETCH_ENTITY_SUCCESS } from 'modules/entity/actionTypes';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { getAddMessageUrl, getNextMessagesUrl as getNextMessagesUrlSelector, getReadMessagesUrl } from './selectors';

/**
 * @param {import('./types').ReadMessagesAction} action
 */
function* readInterventionMessages({ payload }) {
  const url = yield select(getReadMessagesUrl);
  try {
    const { data: entity } = yield call(restClient.request, { url, ...payload.request });
    yield put(actions.readMessagesSuccess(entity));
    document.getElementById('favicon').href = '/favicon.ico';
  } catch (error) {
    yield put(actions.readMessagesFailure(error));
  }
}

/**
 * @param {import('./types').SendInterventionMessageAction} action
 */
function* postInterventionMessage({ payload }) {
  const url = yield select(getAddMessageUrl);
  try {
    const { data: entity } = yield call(restClient.request, { url, ...payload.request });
    yield put(actions.sendMessageSuccess(entity));
    yield put(
      createNotification({
        type: 'success',
        message: {
          id: 'web.comment.reply.success',
          defaultMessage: 'The message has been sent successfully.',
        },
      })
    );
  } catch (error) {
    yield put(actions.sendMessageFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'web.comment.reply.failure',
          defaultMessage: 'The message was not sent.',
        },
      })
    );
  }
}

function receivedMessageFromSocket({ payload }) {
  if (!isCreatedByMyself(payload.message)) {
    document.getElementById('favicon').href = '/favicon-lost-connection.ico';
  }
}

function* fetchMessages({ payload }) {
  const { getMessagesUrl } = payload;
  try {
    const { data = {} } = yield call(restClient.request, { url: getMessagesUrl });
    const { messages, getNextMessagesUrl = null } = data;
    yield put(actions.fetchMessagesSuccess({ messages, getNextMessagesUrl }));
  } catch (error) {
    yield put(actions.fetchMessagesFailure(error));
  }
}

function* fetchNextMessages() {
  const url = yield select(getNextMessagesUrlSelector);
  if (url) {
    try {
      const { data = {} } = yield call(restClient.request, { url });
      const { messages, getNextMessagesUrl = null } = data;
      yield put(actions.fetchNextMessagesSuccess({ messages, getNextMessagesUrl }));
    } catch (error) {
      yield put(actions.fetchNextMessagesFailure(error));
    }
  }
}

export default function* chatSagas() {
  yield takeLatest(actionTypes.READ_MESSAGES, readInterventionMessages);
  yield takeLatest(actionTypes.SEND_MESSAGE, postInterventionMessage);
  yield takeLatest(actionTypes.FETCH_NEXT_MESSAGES, fetchNextMessages);
  yield takeLatest(MESSAGE_RECEIVED_FROM_SOCKET, receivedMessageFromSocket);
  yield takeLatest(FETCH_ENTITY_SUCCESS, fetchMessages);
}
